<template>

     <MainBackground>
          <div class="relative z-10 flex justify-center items-center w-full h-full">

               <transition name="fade" mode="out-in" appear>
                    <BottleSuccess v-if="showBottleSuccessAnimation" />
               </transition>

               <!-- <transition name="fade" mode="out-in" appear>
                    <CameraModal v-if="camera" @toggleOffCamera="toggleCamera" />
               </transition> -->

               <transition name="fade" mode="out-in" appear>
                    <ErrorModal v-if="error" :msg="errorMessage" />
               </transition>

               <transition name="fade" mode="out-in" appear>
                    <LoadingModal v-if="loading" />
               </transition>


               <transition name="fade" mode="out-in" appear>
                    <AnalysingPhotoLoader v-if="analysingPhoto" />
               </transition>
               <!-- header -->
               <MainHeader />


               <div  class="pt-[80px] pb-[130px] sm:pt-[90px] sm:pb-[140px] w-full h-full flex justify-center items-start overflow-y-auto">
                    <transition name="fade" mode="out-in" appear>
                         <router-view @toggleLoading="toggleLoading" @toggleError="toggleError"
                              @toggleBottleSuccess="toggleBottleSuccess" @togglePhotoAnalysis="togglePhotoAnalysis" />
                    </transition>
               </div>
               <!--  footer  -->
               <MainFooter />

          </div>
     </MainBackground>
</template>

<script setup>
import { ref } from 'vue';
import MainBackground from './components/mainBackground.vue';
import LoadingModal from './components/loadingModal.vue';
import ErrorModal from './components/errorModal.vue';
import MainFooter from './components/mainFooter.vue';
import MainHeader from './components/mainHeader.vue';
import BottleSuccess from './components/bottleSuccess.vue';
import AnalysingPhotoLoader from './components/analysingPhotoLoader.vue';







const loading = ref(false);
function toggleLoading(show) {
     loading.value = show;
}




const analysingPhoto = ref(false);
function togglePhotoAnalysis(show) {
     analysingPhoto.value = show;
}




// const camera = ref(false);
// function toggleCamera(show) {
//      camera.value = show;
// }



const error = ref(false);
const errorMessage = ref('');
function toggleError(msg) {
     error.value = true;
     errorMessage.value = msg;
     setTimeout(() => {
          error.value = false;
          errorMessage.value = '';

     }, 4000);
}

const showBottleSuccessAnimation = ref(false);
const toggleBottleSuccess = () => {
     showBottleSuccessAnimation.value = true;

     setTimeout(() => {
        
          showBottleSuccessAnimation.value = false;

     }, 3000);
}



</script>
<style>
/* now everything works normally, no :global needed */
@keyframes float-slow {

     0%,
     100% {
          transform: translate(0, 0) scale(1);
          opacity: 0.9;
     }

     50% {
          transform: translate(30px, -30px) scale(1.05);
          opacity: 1;
     }
}

@keyframes float-medium {

     0%,
     100% {
          transform: translate(0, 0) scale(1);
          opacity: 0.8;
     }

     50% {
          transform: translate(-40px, 40px) scale(1.08);
          opacity: 1;
     }
}

@keyframes float-fast {

     0%,
     100% {
          transform: translate(0, 0) scale(1);
          opacity: 0.8;
     }

     50% {
          transform: translate(50px, -20px) scale(1.03);
          opacity: 0.95;
     }
}

.animate-float-slow {
     animation: float-slow 3s ease-in-out infinite;
}

.animate-float-medium {
     animation: float-medium 2s ease-in-out infinite;
}

.animate-float-fast {
     animation: float-fast 1s ease-in-out infinite;
}

/* keep your fade transition too */
.fade-enter-active,
.fade-leave-active {
     transition: all 0.6s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.fade-enter-from {
     opacity: 0;
     transform: translateY(50px);
}

.fade-enter-to {
     opacity: 1;
     transform: translateY(0);
}

.fade-leave-from {
     opacity: 1;
     transform: translateY(0);
}

.fade-leave-to {
     opacity: 0;
     transform: translateY(-50px);
}
</style>